
"use strict"; // jshint ignore:line

import {
	//AxesHelper,
	Object3D,
	Math as THREEMath,
	AmbientLight,
	HemisphereLight,
	PointLight,
	//PointLightHelper,
	SpotLight,
	//SpotLightHelper,
	//HemisphereLightHelper,
	//DirectionalLightHelper,
	Mesh,
	MeshBasicMaterial,
	//MeshLambertMaterial,
	//MeshStandardMaterial,
	Color,
	Euler,
	Vector3,
	Group,
	SphereGeometry,
	//Matrix3,
	Box3,
	//BoxHelper,
	//ObjectLoader,
	//CubeGeometry,
	Material,
	Sphere,
	//TextureLoader
} from '../../../src/js/three.module.js';

//import { AdditionalObjectText } from '../classes/additional-objects/additional-object-text.js';

import { ObjectLoader } from '../../utils/object-loader.js';

//import { ObjectClickHandler }  from '../../utils/object-click-handler.js';
//import { CommentsHandler } from '../services/CommentsService.js';
import { injector as AdditionalObjectInjector } from '../classes/additional-objects/injector.js';
//import UserActionHistoryService from '../services/UserActionHistoryService.js';

import { buildMaterialParameters, createDefaultMaterial, createMaterialByImageUrl, createTextureByImageUrl } from '../classes/additional-objects/utils.js';

import { createHemisphereColors } from '../../utils/colors.js';

import {
	parseFirstIntersect,
	screenIntersects,
	PlaceSolver,
	//rotateAroundWorldAxis,
	//roundVector
} from '../GameTools.js';

import { getObjectLoader, getTextureLoader } from '../../utils/loaders/loader-manager.js';

export default class AdditionalObjectService extends Group {
	
	static $inject = ["$rootScope","$timeout","gettextCatalog","$userAssets","userActionHistoryService","entitySelectionService","$injector"]; // jshint ignore:line

	constructor( $rootScope, $timeout, gettextCatalog, $userAssets, userActionHistoryService, entitySelectionService, $injector ) {

		super();
		
		var self = this;

		AdditionalObjectService.getInstance = () => self;

		var textureLoader = /* new TextureLoader() */ getTextureLoader();

		var additionalObjectsService = window.additionalObjectsService = this;

		const AdditionalObject = window.AdditionalObject = AdditionalObjectInjector();

		const {
			JSON:  AdditionalObjectJSON,
			Light: AdditionalObjectLight,
			Cube:  AdditionalObjectCube,
			Plane: AdditionalObjectPlane,
			Text:  AdditionalObjectText
		} = AdditionalObject;

	//	this.selected_object = null;

		this.templates = {};
		this.hash_templates_map = {};

		/**********************/

		this.objects = {};
		this.objects_by_hash = {};
		this.objects_hashs = {};
		this.objects_hashs_arr = [];

		this.objectHashUpdateNeeded = true;

		/**********************/

		$rootScope.$on( "editorEnabled", function() {
			for (var uuid in additionalObjectsService.objects) {
				if (additionalObjectsService.objects[ uuid ] && additionalObjectsService.objects[ uuid ].wireframe) {
					additionalObjectsService.objects[ uuid ].wireframe.visible = additionalObjectsService.objects[ uuid ].selected;
				}
			}
		});

		$rootScope.$on( "editorDisabled", function() {
			for (var uuid in additionalObjectsService.objects) {
				if (additionalObjectsService.objects[ uuid ] && additionalObjectsService.objects[ uuid ].wireframe) {
					additionalObjectsService.objects[ uuid ].wireframe.visible = false;
				}
			}
		});

		/**********************/

		this.update = function updateAdditionalObjectService() {
			if (this.objectHashUpdateNeeded) {
				this.objectHashUpdateNeeded = false;

				/** @TODO: Poista objects_hashs'n täyttäminen muualta kuin tästä */

				$timeout(function() {
					// console.debug( "updateAdditionalObjectService :: this.objectHashUpdateNeeded = true" );

					/************/

					delete additionalObjectsService.objects_by_hash;
					additionalObjectsService.objects_by_hash = {};
					for (var uuid in additionalObjectsService.objects) {
						additionalObjectsService.objects_by_hash[ additionalObjectsService.objects[uuid].obj_hash ] = additionalObjectsService.objects_by_hash[ additionalObjectsService.objects[uuid].obj_hash ] || {};
						additionalObjectsService.objects_by_hash[ additionalObjectsService.objects[uuid].obj_hash ][ uuid ] = additionalObjectsService.objects[ uuid ];
					}

					/************/

					delete additionalObjectsService.objects_hashs;
					additionalObjectsService.objects_hashs = {};

					additionalObjectsService.objects_hashs_arr.splice( 0, additionalObjectsService.objects_hashs_arr.length );

					for (var hash in additionalObjectsService.objects_by_hash) {
						var first   = additionalObjectsService.objects_by_hash[ hash ][ Object.keys( additionalObjectsService.objects_by_hash[ hash ])[0] ];
						var count   = Object.keys( additionalObjectsService.objects_by_hash[ hash ] ).length;
						var objects = additionalObjectsService.objects_hashs[ hash ] = { hash: hash, title: hash, single: count == 1 };

						additionalObjectsService.objects_hashs_arr.push( objects );

						try {
							if (objects.single) {
								if (first.title) objects.title = first.title;
							} else {
								if (first.$template) {
									objects.title = gettextCatalog.getString( "AdditionalObject from template {{ title }}", { title: first.$template.title || first.$template.$key });
								} else if (first.type == "json") {
									if (first.opts.source == "url") {
										objects.title = gettextCatalog.getString( "AdditionalObject from url {{ source_url }}", first.opts );
									} else if (first.opts.source == "attachment") {
										objects.title = gettextCatalog.getString( "AdditionalObject from attachment {{ attachment_uid }}", first.opts );
									} else {
										objects.title = gettextCatalog.getString( "label:additionalObject.json.Object3D" );
									}
								} else if (first.type == "cube") {
									if (first.size.x.toFixed(3) + first.size.y.toFixed(3) + first.size.z.toFixed(3) == "0.2100.2950.001") {
										objects.title = gettextCatalog.getString( "label:additionalObject.cube.a4" );
									} else {
										objects.title = gettextCatalog.getString( "label:additionalObject.cube" ) + 
										 ", " +
										 first.size.x + " x " +
										 first.size.z + " x " +
										 first.size.y + " m";
									}
								}
							}
						} catch (error) {
							console.error( error );
						}
					}

					additionalObjectsService.objects_hashs_arr.sort(function( a, b ){
						return a.hash.localeCompare( b.hash );
					});
				});
			}
		}

		/**********************/

	/*	entitySelectionService.injectTypeHandler( "additionalObject", function( obj ){

			if( self.selected_object ){
				self.selected_object.toggleSelect( false );
			}

			if( obj != null ){
				if( self.selected_object = self.solveObject( obj ) || null ){
					self.selected_object.toggleSelect( true );
				}
			} else {
				self.selected_object = null;
			}
			return self.selected_object;
		});*/

		/**********************/

		this.setObjectTemplates = function( objs ) {
			for (var key in objs) {
				try {
					this.setObjectTemplate( key, JSON.parse( JSON.stringify( objs[key] )));
				} catch( error ) {
					console.error( "AdditionalObjectService.setObjectTemplates()", error );
				}
			}
		};

		this.setObjectTemplate = function( key, template ) {

			this.templates[ key ] = template;

			template.disableOptsChange = template.disableOptsChange == null ? true : !!template.disableOptsChange;

			template.$key  = key;
			template.$objs = [];

			template.$objs.push = (function( v ){
				if (this.indexOf(v) == -1) Array.prototype.push.call( this, v );
			}).bind( template.$objs );

			template.remove = (function( obj, idx ){
				if ((idx = this.$objs.indexOf( obj )) == -1) return console.warn( "Unable to remove object from template, object not found" );
				this.$objs.splice( idx, 1 );
				delete obj.$template;
			}).bind( template );

			return template;
		};

		this.genFromTemplate = function( key ) {

			var tpl = this.templates[ key ];

			if (!tpl) return null;

			var obj;

			switch (tpl.type) {
				case "json":
					switch (tpl.source) {
						case "attachment":
							obj = this.generateFromAttachmentJson( tpl );
							break;

						case "url": 
							obj = this.generateFromUrl( tpl );
							break;
					}
					break;

				case "plane":

					let material = "#ffffff", { width, height, texture_img_url, texture_img_uid } = tpl;

					if (texture_img_url) {
						material = { texture_img_url };
					} else if (texture_img_uid) {
						material = { texture_img_uid };
					}

					obj = this.generatePlane( width || 1, height || 1, material );
					break;
			}

			if (!obj) return null;

			if (typeof tpl.availPlanes == "object" && typeof obj.availPlanes == "object") {

				if (typeof tpl.availPlanes.floor   != "undefined") obj.availPlanes.floor   = !!tpl.availPlanes.floor;

				if (typeof tpl.availPlanes.wall    != "undefined") obj.availPlanes.wall    = !!tpl.availPlanes.wall;

				if (typeof tpl.availPlanes.ceiling != "undefined") obj.availPlanes.ceiling = !!tpl.availPlanes.ceiling;
			}

			return obj;
		};

		this.solveObject = function( uuid ){
			if( typeof uuid == "object" && uuid.uuid ){
				if (uuid.userData && uuid.userData.additionalObject) {
					return this.solveObject( uuid.userData.additionalObject.uuid );
				} else {
					return this.solveObject( uuid.uuid );
				}
			} else if( typeof uuid != "string" ){
				throw new Error("Invalid argument");
			} else if( this.objects[ uuid ]){
				return this.objects[ uuid ];
			}

			throw new Error("Not found");
		}

		this.selectObject = function( obj ){
			obj = !obj ? null : this.solveObject( obj );
			return entitySelectionService.selected_entity = obj;
		};

		this.removeObject = function( uuid ){
			if( uuid == null ) return;

			var obj = this.solveObject( uuid );
			uuid = obj.uuid;

			additionalObjectsService.objectHashUpdateNeeded = true;

			if (obj.$template) obj.$template.remove( obj );
			if (obj.wireframe) obj.wireframe.parent.remove( obj.wireframe );

			this.remove( obj.mesh );

			window.ContextMenuService.destroy( "preview-additionalObject-"+obj.uuid );

			delete this.objects[ obj.uuid ];
		}

		this.generateFromJson = function( json, opts ) {

			var obj = new AdditionalObject.JSON( json );

			if (opts) {
				if (opts.source == "attachment" && opts.attachment_uid) {
					obj.opts.source         = opts.source;
					obj.opts.attachment_uid = opts.attachment_uid;
				} else if (opts.source == "url" && opts.source_url) {
					obj.opts.source         = opts.source;
					obj.opts.source_url     = opts.source_url;
				}
			}

			return obj;
		};
		this.generateFromAttachmentJson = function( opts, placeholder ) {
			var ret = new AdditionalObject.JSON( (new Object3D()).toJSON() );
			ret.opts.source         = "attachment";
			ret.opts.attachment_uid = opts.attachment_uid;
			
			ret.$$inner.add( placeholder = placeholder || new Mesh( new SphereGeometry( 0.3, 32, 32 ), new MeshBasicMaterial({ color: 0xaaaaaa }) ) );

			$userAssets.getAttachmentData.asTHREEObject( opts.attachment_uid )
			.then(function( object ){
				object.updateMatrix();
				if ($userAssets.assets.attachment_objects[ opts.attachment_uid ]) object.uuid = $userAssets.assets.attachment_objects[ opts.attachment_uid ].uuid;
				var json = object.toJSON( );
				ret.setJson( json );
				ret.setMesh();
			}).catch(function( error ){
				console.error( error );
				throw error;
			});

			return ret;
		};
		this.generateFromUrl = function( opts, placeholder, callback ) {
			var ret = new AdditionalObject.JSON( (new Object3D()).toJSON() );

			ret.opts.source     = "url";
			ret.opts.source_url = opts.source_url;
			
			ret.$$inner.add( placeholder = placeholder || new Mesh( new SphereGeometry( 0.3, 32, 32 ), new MeshBasicMaterial({ color: 0xaaaaaa }) ) );

			callback = (typeof callback == "function") ? callback : function( error ) { if (error) console.error( "additionalObjectsService.generateFromUrl ::", error ); }

			ObjectLoader.promiseLoad( ret.opts.source_url ).then(function( object ) {
				object.updateMatrix();

				var json = object.toJSON( );

				ret.setJson( json );
				ret.setMesh();
				
				try {
					callback( null, ret );
				} catch(e) {}
			}).catch(function( error ){
				console.error( error );
				callback( error );
			});

			return ret;
		};

		this.generateCube = function( width, height, depth, material ) {
			if (typeof arguments[0] == "object") {

				var opts = arguments[0];

				if (opts instanceof AdditionalObject.Cube) {
					opts = {};
					for (var key in arguments[0].opts) opts[ key ] = arguments[0].opts[key];
					delete opts.uuid;
				}

				return AdditionalObject.Cube.fromOpts( opts );
			}

			material = handleMaterial( material );

			return new AdditionalObject.Cube( width,  height, depth, material );
		};

		this.generatePlane = function( width, height, material ) {
			if (typeof arguments[0] == "object") {

				var opts = arguments[0];

				if (opts instanceof AdditionalObject.Plane) {
					opts = {};
					for (var key in arguments[0].opts) opts[ key ] = arguments[0].opts[key];
					delete opts.uuid;
				}

				return AdditionalObject.Plane.fromOpts( opts );
			}

			return new AdditionalObject.Plane( width,  height, handleMaterial( material ));
		};

		this.generateTextPlane = ( width, height, text ) => {

			if (typeof arguments[0] == "object") {

				var opts = arguments[0];

				if (opts instanceof AdditionalObjectText) {
					opts = {};
					for (var key in arguments[0].opts) opts[ key ] = arguments[0].opts[key];
					delete opts.uuid;
				}

				return AdditionalObjectText.fromOpts( opts );
			}

			return new AdditionalObjectText( text, width, height );
		};

		this.duplicateObject = function( object, alternatePosition ){
			var tpl = object.$template;
			if (tpl && tpl.max_count && tpl.$objs.length >= tpl.max_count) return console.warn( "AdditionalObjectService.duplicateObject :: Could not duplicate. The template is already in max count" );

			var obj;
			switch( object.type ){
				case "cube":
					/*** @TODO: Ajantasaista */
					obj = this.generateCube( object );
					obj.mesh.position.copy( object.mesh.position );
					obj.mesh.rotation.copy( object.mesh.rotation );
					break;
				case "plane":
					/*** @TODO: Ajantasaista */
					obj = this.generatePlane( object );
					obj.mesh.position.copy( object.mesh.position );
					obj.mesh.rotation.copy( object.mesh.rotation );
					break;
				case "json":
					switch (object.opts.source) {
						case "attachment":
							obj = this.generateFromAttachmentJson( object.opts );
							break;
						case "url": 
							obj = this.generateFromUrl( object.opts );
							break;
					}
					if (!obj) return;

					if (object.$template) obj.$setTemplate( object.$template );
					obj.mesh.position.copy( object.mesh.position );
					obj.mesh.rotation.copy( object.mesh.rotation );
					break;
				case "light":

					var json = object.toJSON();

					delete json.uuid;

					obj = AdditionalObject.Light.loadSave( json );

					break;
			}

			// Siirretään objektia hieman kohti pelaajaa jottei täsmälleen sama sijainti hämää käyttäjää
			if (obj && alternatePosition == true) try {
				var vec = player.headPos.clone().sub( obj.mesh.position );

				vec.y = 0; // Oletetaan alkup. objektin olevan hyvällä korkeudella

				var nlen = 0.25; // Sopivan pieni, mutta sopivan suuri etäisyys

				if (vec.length() < nlen) {
					nlen = vec.length() / 2;
				}

				obj.mesh.position.addScaledVector( vec.normalize(), nlen );
			} catch (error) { console.error( error ); } 

			return obj;
		};

		this.refreshObjs = function(){
	//		this.objects_by_hash = {};
			for (let hash in this.objects ){
				this.objects[ hash ];
			}

			for (let hash in this.objects_by_hash ){
				if( Object.keys( this.objects_by_hash[ hash ]).length == 0 ){
					delete this.objects_by_hash[ hash ];
				}
			}

			additionalObjectsService.objectHashUpdateNeeded = true;
		};


		function handleMaterial( material, callback ){

			if( material instanceof Material ){
				return material;
			} else if (typeof material == "number") {
				return { color: material };
			} else if (typeof material == "string") {
				if (material.match( /^B2[A-F0-9]{14}$/ )) {
					return { $img_uid: material, color: new Color( "#ffffff" )  };
				}
				return { color: new Color( material )};
			} else if (typeof material == "object") {
				if (material instanceof Color) {
					return { color: material };
				} else if (material.texture_img_uid) {
					return { $img_uid: material.texture_img_uid, color: new Color( "#ffffff" )  };
				} else if (material.texture_img_url) {
					return createMaterialByImageUrl( material.texture_img_url );
				} else {
					debugger;
				}
				return material;
			}
			throw new Error("Invalid argument material");
		}


		/*
		██    ██ ███████ ███████ ██████   █████   ██████ ████████ ███████ ██   ██ ██ ███████ ████████  ██████  ██████  ██    ██
		██    ██ ██      ██      ██   ██ ██   ██ ██         ██    ██      ██   ██ ██ ██         ██    ██    ██ ██   ██  ██  ██
		██    ██ ███████ █████   ██████  ███████ ██         ██    ███████ ███████ ██ ███████    ██    ██    ██ ██████    ████
		██    ██      ██ ██      ██   ██ ██   ██ ██         ██         ██ ██   ██ ██      ██    ██    ██    ██ ██   ██    ██
		 ██████  ███████ ███████ ██   ██ ██   ██  ██████    ██    ███████ ██   ██ ██ ███████    ██     ██████  ██   ██    ██
		*/

		userActionHistoryService.addActs({
			"additionalObject.remove": {
				"do": function( obj ) {
					if (obj instanceof AdditionalObject.JSON) {
						return userActionHistoryService.acts[ "additionalObject.json.remove" ].do( obj );
					} else if (obj instanceof AdditionalObject.Light) {
						return userActionHistoryService.acts[ "additionalObject.light.remove" ].do( obj );
					}

					userActionHistoryService.acts[ "additionalObject.remove" ].redo({ uuid: obj.uuid });
				},
				"redo": function( act ) {
					additionalObjectsService.removeObject( act.uuid );
				}
			},
			"additionalObject.move": {
				"do"   : function( obj, position, rotation ){
					userActionHistoryService.addUndo( "additionalObject.move", {
						uuid         : obj.uuid,
						old_rotation : obj.mesh.rotation.clone(),
						new_rotation : (rotation ? obj.mesh.rotation.copy( rotation ) : obj.mesh.rotation).clone(),
						old_position : obj.mesh.position.clone(),
						new_position : (position ? obj.mesh.position.copy( position ) : obj.mesh.position).clone()
					});

				},
				"undo" : function( act, obj ){ if( obj = additionalObjectsService.solveObject( act.uuid )){ obj.mesh.position.copy( act.old_position ); obj.mesh.rotation.copy( act.old_rotation ); }},
				"redo" : function( act, obj ){ if( obj = additionalObjectsService.solveObject( act.uuid )){ obj.mesh.position.copy( act.new_position ); obj.mesh.rotation.copy( act.new_rotation ); }}
			},
			"additionalObject.rotate": {
				"do"   : function( obj, val ) {
					userActionHistoryService.addUndo( "additionalObject.rotate", {
						uuid: obj.uuid,
						old_rotation: obj.mesh.rotation.clone(),
						new_rotation: obj.mesh.rotation.copy( val )
					});
				},
				"undo" : function( act, obj ){ if (obj=additionalObjectsService.objects[ act.uuid ]) obj.mesh.rotation.copy( act.old_rotation ); },
				"redo" : function( act, obj ){ if (obj=additionalObjectsService.objects[ act.uuid ]) obj.mesh.rotation.copy( act.new_rotation ); }
			},
			"additionalObject.setZOffset": {
				"do": function( obj, val ){
					userActionHistoryService.addUndo( "additionalObject.setZOffset", { uuid: obj.uuid, old_z_offset: obj.z_offset, new_z_offset: obj.z_offset = val });
					obj.setPlaceByIntersect();
				},
				"undo"          : function( act, obj ){ if( obj = additionalObjectsService.solveObject( act.uuid )) obj.z_offset  = act.old_z_offset; },
				"redo"          : function( act, obj ){ if( obj = additionalObjectsService.solveObject( act.uuid )) obj.z_offset  = act.new_z_offset; },
				"$postCallback" : function( act, obj ){ if( obj = additionalObjectsService.solveObject( act.uuid )) obj.setPlaceByIntersect(); }
			},
			"additionalObject.text.create": {
				"do": function( w, h, text, position, rotation ) {

					var intersect, plane;
					
					if (typeof position == "number" && typeof rotation == "number") {
						intersect = parseFirstIntersect.wall( screenIntersects( position, rotation ).filter( v => !!v.face ));
					}

					if (intersect) {
						plane = additionalObjectsService.generateTextPlane( w, h, text );
						plane.setPlaceByIntersect( intersect ); 
					} else if (typeof position == "object" && typeof rotation == "object") {
						plane = additionalObjectsService.generateTextPlane( w, h, text );
						plane.mesh.position.copy( position );
						plane.mesh.rotation.copy( rotation );
					}

					if (!plane) throw "invalid arguments";

					userActionHistoryService.addUndo( "additionalObject.text.create", {
						uuid : plane.uuid,
						text : text,
						w    : w,
						h    : h,
						pos  : plane.mesh.position.toArray(),
						rot  : plane.mesh.rotation.toArray()
					});

					return plane;
				},
				"undo": function( act ) {
					additionalObjectsService.removeObject( act.uuid );
				},
				"redo": function( act ) {
					var plane = additionalObjectsService.generateTextPlane( act.w, act.h, act.text );
					plane.changeUuid( act.uuid );
					plane.mesh.position.fromArray( act.pos );
					plane.mesh.rotation.fromArray( act.rot );
				}
			},
			"additionalObject.plane.create": {
				"do": function( w, h, clr, position, rotation ){

					/**
					if (!position) {
						position = PlacePositionSolver( null, null, { floor: true });
					}

					if (!rotation) {
						rotation = new THREE.Euler( 0, player.av, 0 );
					}
					
					if (!(position instanceof THREE.Vector3) || !(rotation instanceof THREE.Euler)) return;

					plane = additionalObjectsService.generatePlane( w, h, clr );

					plane.mesh.position.copy( position );
					plane.mesh.rotation.copy( rotation );
						
					*/


					var intersect, plane;
					if (typeof position == "number" && typeof rotation == "number") {
						intersect = parseFirstIntersect.wall( screenIntersects( position, rotation ).filter(function(v){ return !!v.face; }));
					}

					if (intersect) {
						plane = additionalObjectsService.generatePlane( w, h, clr);
						plane.setPlaceByIntersect( intersect ); 
					} else if (typeof position == "object" && typeof rotation == "object") {
						plane = additionalObjectsService.generatePlane( w, h, clr);
						plane.mesh.position.copy( position );
						plane.mesh.rotation.copy( rotation );
					}

					if (!plane) throw "invalid arguments";

					userActionHistoryService.addUndo( "additionalObject.plane.create", {
						uuid : plane.uuid,
						clr  : clr,
						w    : w,
						h    : h,
						pos  : plane.mesh.position.toArray(),
						rot  : plane.mesh.rotation.toArray()
					});

					return plane;
				},
				"undo": function( act ){
					additionalObjectsService.removeObject( act.uuid );
				},
				"redo": function( act ){
					var plane = additionalObjectsService.generatePlane( act.w, act.h, act.clr );
					plane.changeUuid( act.uuid );
					plane.mesh.position.fromArray( act.pos );
					plane.mesh.rotation.fromArray( act.rot );
				}
			},
			"additionalObject.cube.create": {
				"do": function( w, h, d, clr, position, rotation ) {

					var place = PlaceSolver.extend( position, rotation );

					position = place.position;
					rotation = place.rotation;
					
					if (!(position instanceof Vector3) || !(rotation instanceof Euler)) return;

					var data = {
						uuid : THREEMath.generateUUID(),
						w    : w,
						h    : h,
						d    : d,
						clr  : clr,
						pos  : position.toArray(),
						rot  : rotation.toArray()
					};
					
					var obj = userActionHistoryService.acts[ "additionalObject.cube.create" ].redo( data );

					userActionHistoryService.addUndo( "additionalObject.cube.create", data );

					return obj;
				},
				"undo": function( act ){
					additionalObjectsService.removeObject( act.uuid );
				},
				"redo": function( act ){

					var cube = additionalObjectsService.generateCube( act.w, act.h, act.d, act.clr );

					cube.changeUuid( act.uuid );

					cube.mesh.position.fromArray( act.pos );
					cube.mesh.rotation.fromArray( act.rot );

					return cube;
				}
			},
			"additionalObject.cube.remove": {
				"do": function( cube ){

					cube = additionalObjectsService.solveObject( cube );
					
					if (!cube) return;

					let material = Array.isArray( cube.mesh.material ) ? cube.mesh.material[0] : cube.mesh.material;

					userActionHistoryService.addUndo( "additionalObject.cube.remove", {
						uuid : cube.uuid,
						clr  : material ? ("#" + material.color.getHexString()) : undefined,
						w    : cube.width,
						h    : cube.height,
						d    : cube.depth,
						pos  : cube.mesh.position.toArray(),
						rot  : cube.mesh.rotation.toArray()
					});
					additionalObjectsService.removeObject( cube.uuid );

					return cube;
				},
				"undo": function( act ){ userActionHistoryService.acts["additionalObject.cube.create"].redo( act ); },
				"redo": function( act ){ userActionHistoryService.acts["additionalObject.cube.create"].undo( act ); }
			},
			"additionalObject.cube.setSize": {
				"do": function( cube, w, h, d ){
					var ch = { uuid: cube.uuid };
					if( w != null ){ ch.old_width  = cube.opts.width;  ch.new_width  = cube.opts.width  = parseFloat(w); }
					if( h != null ){ ch.old_height = cube.opts.height; ch.new_height = cube.opts.height = parseFloat(h); }
					if( d != null ){ ch.old_depth  = cube.opts.depth;  ch.new_depth  = cube.opts.depth  = parseFloat(d); }
					cube.optsChanged();
					userActionHistoryService.addUndo( "additionalObject.cube.setSize", ch );
				},
				"undo": function( act, cube ){
					if(!(cube = additionalObjectsService.solveObject( act.uuid ))) return;
					act.old_width==null  || (cube.opts.width  = act.old_width);
					act.old_height==null || (cube.opts.height = act.old_height);
					act.old_depth==null  || (cube.opts.depth  = act.old_depth);
				},
				"redo": function( act, cube ){
					if(!(cube = additionalObjectsService.solveObject( act.uuid ))) return;
					act.new_width==null  || (cube.opts.width  = act.new_width);
					act.new_height==null || (cube.opts.height = act.new_height);
					act.new_depth==null  || (cube.opts.depth  = act.new_depth);
				},
				"$postCallback" : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.optsChanged(); }
			},
			"additionalObject.cube.setTexture": {
				"do": function( cube, img_uid ){
					userActionHistoryService.addUndo( "additionalObject.cube.setTexture", { uuid: cube.uuid, old_img: cube.opts.texture_img_uid, new_img: cube.opts.texture_img_uid = img_uid });
					cube.optsChanged();
				},
				"undo"          : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.opts.texture_img_uid = act.old_img; },
				"redo"          : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.opts.texture_img_uid = act.new_img; },
				"$postCallback" : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) { cube.optsChanged(); }}
			},
			"additionalObject.cube.setColor": {
				"do": function( cube, color ){
					userActionHistoryService.addUndo( "additionalObject.cube.setColor", { uuid: cube.uuid, old_color: cube.opts.color, new_color: cube.opts.color = color });
					cube.optsChanged();
				},
				"undo"          : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.opts.color  = act.old_color; },
				"redo"          : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.opts.color  = act.new_color; },
				"$postCallback" : function( act, cube ){ if( cube = additionalObjectsService.solveObject( act.uuid )) cube.optsChanged(); }
			},
			"additionalObject.json.create": {
				"do": function( json, position, rotation, opts ) {
					opts = opts || {};

					var avail_planes = opts.avail_planes || opts.availPlanes || undefined;

					var boundingRadius;

					try {

						let obj = (/* new ObjectLoader() */ getObjectLoader()).parse( json );

						var box = new Box3().setFromObject( obj );

						var boundingSphere = new Sphere();

						boundingRadius = box.getBoundingSphere( boundingSphere ).radius;

					} catch (error) {
						console.error( error );
					}

					var place = PlaceSolver.extend( position, rotation, null, null, opts.availPlanes, { far: 5, boundingRadius: boundingRadius });

					position = place.position;
					rotation = place.rotation;
					
					if (!(position instanceof Vector3) || !(rotation instanceof Euler)) return;

					var data = {
						uuid           : THREEMath.generateUUID(),
						json           : json,
						pos            : position.toArray(),
						rot            : rotation.toArray(),
						scale          : opts.scale,
						z_offset       : opts.z_offset,
						source         : opts.source,
						source_url     : opts.source_url,
						attachment_uid : opts.attachment_uid,
						avail_planes   : avail_planes
					};

					var obj = userActionHistoryService.acts[ "additionalObject.json.create" ].redo( data );

					userActionHistoryService.addUndo( "additionalObject.json.create", data );

					return obj;
				},
				"undo": function( act ) {
					additionalObjectsService.removeObject( act.uuid );
				},
				"redo": function( act ) {
					var obj = additionalObjectsService.generateFromJson( act.json, act );

					obj.scale    = obj.opts.scale    = act.scale    != null ? act.scale    : 1;
					obj.z_offset = obj.opts.z_offset = act.z_offset != null ? act.z_offset : 0;

					obj.mesh.scale.set( obj.scale, obj.scale, obj.scale );

					obj.changeUuid( act.uuid );

					obj.mesh.position.fromArray( act.pos );
					obj.mesh.rotation.fromArray( act.rot );
					
					if (act.title) obj.title = act.title;

					if (typeof act.avail_planes == "object" ) {
						obj.availPlanes = {
							floor:   !!act.avail_planes.floor,
							wall:    !!act.avail_planes.wall,
							ceiling: !!act.avail_planes.ceiling
						};
					}

					return obj;
				}
			},
			"additionalObject.json.remove": {
				"do": function( obj ) {
					var act = {
						uuid:         obj.uuid,
						title:         obj.title,
						scale:        obj.scale,
						z_offset:     obj.z_offset,
						json:         obj.opts.json,
						pos:          obj.mesh.position.toArray(),
						rot:          obj.mesh.rotation.toArray(),
						avail_planes: obj.availPlanes
					};

					userActionHistoryService.acts[ "additionalObject.json.remove" ].redo( act );

					userActionHistoryService.addUndo( "additionalObject.json.remove", act );

				},
				"undo": function( act ) {
					return userActionHistoryService.acts[ "additionalObject.json.create" ].redo( act );
				},
				"redo":function( act ) {
					return userActionHistoryService.acts[ "additionalObject.json.create" ].undo( act );
				}
			},
			"additionalObject.light.create": {
				"do": function( stype, position, rotation ) {

					var place = PlaceSolver.extend( position, rotation );

					position = place.position;
					rotation = place.rotation;
					
					if (!(position instanceof Vector3) || !(rotation instanceof Euler)) return;


					var act = {
						stype : stype,
						uuid  : THREEMath.generateUUID(),
						color : "#FFFFFF",
						pos   : position.toArray(),
						rot   : rotation.toArray()
					}

					var obj = userActionHistoryService.acts["additionalObject.light.create"].redo( act );

					userActionHistoryService.addUndo( "additionalObject.light.create", act );

					return obj;
				},
				"undo": function( act ) {
					additionalObjectsService.removeObject( act.uuid );
				},
				"redo": function( act ) {
					var obj;

					// @TODO: Lisää .act, .penumbra, .disabled

					switch (act.stype) {
						case "PointLight":   obj = new PointLight(   act.color || 0xffffff, act.intensity || undefined ); break;
						case "SpotLight":    obj = new SpotLight(    act.color || 0xffffff, act.intensity || undefined, undefined, undefined, 0.3 ); break;
						case "AmbientLight": obj = new AmbientLight( act.color || 0xffffff, act.intensity ); break;

						case "HemisphereLight":
							let { skyColor, groundColor } = createHemisphereColors( act.color || 0xffffff );
							obj = new HemisphereLight( skyColor, groundColor, act.intensity );
							break;
						

						default: return null;
					}

					obj = new AdditionalObject.Light( obj );
					obj.changeUuid( act.uuid );
					obj.mesh.position.fromArray( act.pos );

					if (act.title) obj.title = act.title;

					if (typeof act.disabled != "undefined") obj.disabled = !!act.disabled;

					if (act.rot) obj.mesh.rotation.fromArray( act.rot );
					if (act.qua) obj.mesh.quaternion.fromArray( act.qua );

					return obj;
				}
			},
			"additionalObject.light.remove": {
				"do": function( obj ) {
					var act = {
						uuid:         obj.uuid,
						title:        obj.title,
						stype:        obj.stype || obj.mesh.type,
						color:        obj.color,
						intensity:    obj.intensity,
						angle:        obj.angle,
						disabled:     !!obj.disabled,
						pos:          obj.mesh.position.toArray(),
						rot:          obj.mesh.rotation.toArray(),
					};

					userActionHistoryService.acts[ "additionalObject.light.remove" ].redo( act );

					userActionHistoryService.addUndo( "additionalObject.light.remove", act );

				},
				"undo": function( act ) {
					return userActionHistoryService.acts[ "additionalObject.light.create" ].redo( act );
				},
				"redo":function( act ) {
					return userActionHistoryService.acts[ "additionalObject.light.create" ].undo( act );
				}
			}
		});
	}
}
